import { Appointment } from '../../../types';

function eventDateTimeToMs(event: Appointment): number {
  const dayMs = new Date(event.date).getTime();
  const minutesMs = event.time * 60 * 1000;
  return dayMs + minutesMs;
}

// "Current" event = the latest event on the timeline by date+time, regardless
// of status. Matches the prototype mock data (ha-series-redesign.html L778-790
// HA_DATA): currentApptId is always the chronologically last appointment, even
// when its status is COMPLETED or CANCELLED.
export function findCurrentEvent(events: Appointment[]): Appointment | null {
  if (events.length === 0) {
    return null;
  }

  let latest = events[0];
  let latestMs = eventDateTimeToMs(latest);

  for (let eventsIndex = 1; eventsIndex < events.length; eventsIndex += 1) {
    const event = events[eventsIndex];
    const eventMs = eventDateTimeToMs(event);
    if (eventMs >= latestMs) {
      latest = event;
      latestMs = eventMs;
    }
  }

  return latest;
}
